(function () {
  'use strict';
  // ct-availability-default: make the "In stock" availability filter checked
  // by default on every collection/search page that has facets, unless the
  // customer has explicitly unchecked it (remembered in localStorage so it
  // stays off for the rest of their visits until they check it again).
  var STORAGE_KEY = 'ct_show_out_of_stock';
  var CHECKBOX_SELECTOR = 'input[type="checkbox"][name="filter.v.availability"][value="1"]';

  function optedOutOfDefault() {
    try {
      return localStorage.getItem(STORAGE_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function setOptedOut(value) {
    try {
      if (value) {
        localStorage.setItem(STORAGE_KEY, '1');
      } else {
        localStorage.removeItem(STORAGE_KEY);
      }
    } catch (e) {}
  }

  // If the URL already has an explicit availability filter (whichever value),
  // the customer (or a shared/bookmarked link) has already made a choice for
  // this page load — don't override it.
  function urlHasAvailabilityFilter() {
    return /(^|[?&])filter\.v\.availability=/.test(window.location.search);
  }

  function applyDefaultInStockFilter() {
    if (optedOutOfDefault()) return;
    if (urlHasAvailabilityFilter()) return;

    var checkbox = document.querySelector(CHECKBOX_SELECTOR);
    if (!checkbox || checkbox.checked) return;

    var formEl = checkbox.closest('form');
    var facetFormEl = checkbox.closest('facet-filters-form');
    var FacetFiltersFormClass = window.customElements ? customElements.get('facet-filters-form') : null;

    if (!formEl || !facetFormEl || !FacetFiltersFormClass || typeof facetFormEl.createSearchParams !== 'function') {
      return;
    }

    checkbox.checked = true;

    var searchParams = facetFormEl.createSearchParams(formEl);
    FacetFiltersFormClass.renderPage(searchParams, null, true);
  }

  // Remember when the customer explicitly turns "In stock" off (or back on),
  // so future page loads this visit respect their choice instead of
  // re-forcing the default.
  document.addEventListener('change', function (event) {
    var el = event.target;
    if (el && el.matches && el.matches(CHECKBOX_SELECTOR)) {
      setOptedOut(!el.checked);
    }
  });

  function init() {
    applyDefaultInStockFilter();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
